import { render, staticRenderFns } from "./userProspection.vue?vue&type=template&id=918d7cb6&scoped=true"
import script from "./userProspection.vue?vue&type=script&lang=js"
export * from "./userProspection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918d7cb6",
  null
  
)

export default component.exports